import i18next from 'i18next';

import en from './navigation-i18n/en';
import it from './navigation-i18n/it';

import { type NavigationItem } from 'app/store/fuse/navigationSlice';

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const navigationConfig: NavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		translate: 'DASHBOARDS',
		type: 'group',
		icon: 'bar-chart',
		children: [
			{
				id: 'dashboard_user',
				title: 'User Dashboard',
				translate: 'DASHBOARD_USER',
				auth: ['user', 'salesperson'],
				type: 'item',
				icon: 'home-analytics',
				url: 'summary'
			},
			{
				id: 'kpis',
				title: 'KPIs',
				translate: 'DASHBOARD_KPIS',
				auth: ['admin'],
				type: 'item',
				icon: 'performance',
				url: 'kpis/goals'
			}
			// {
			// 	id: 'powerbi_stats',
			// 	title: 'PowerBI stats',
			// 	translate: 'DASHBOARD_POWERBI_STATS',
			// 	auth: 'user',
			// 	type: 'item',
			// 	icon: 'file-chart',
			// 	url: 'powerbi-stats'
			// }
		]
	},
	{
		id: 'registries',
		title: 'Registries',
		translate: 'REGISTRIES',
		type: 'group',
		icon: 'format-list-bulleted-square',
		children: [
			{
				id: 'companies',
				title: 'Companies',
				translate: 'COMPANIES',
				auth: ['user', 'salesperson'],
				type: 'item',
				icon: 'domain',
				url: 'companies'
				// children: [
				// 	{
				// 		id: 'customers',
				// 		title: 'Customers',
				// 		translate: 'CUSTOMERS',
				// 		auth: ['user', 'salesperson'],
				// 		type: 'item',
				// 		url: 'companies/customers'
				// 	},
				// 	{
				// 		id: 'suppliers',
				// 		title: 'Suppliers',
				// 		translate: 'SUPPLIERS',
				// 		auth: ['user', 'salesperson'],
				// 		type: 'item',
				// 		url: 'companies/suppliers'
				// 	},
				// 	{
				// 		id: 'others',
				// 		title: 'Others',
				// 		translate: 'OTHERS',
				// 		auth: ['user', 'salesperson'],
				// 		type: 'item',
				// 		url: 'companies/others'
				// 	}
				// ]
			},
			{
				id: 'people',
				title: 'People',
				translate: 'PEOPLE',
				auth: 'user',
				type: 'item',
				icon: 'card-account-details-outline',
				url: 'people/list'
			},
			{
				id: 'items',
				title: 'Items',
				translate: 'ITEMS',
				auth: 'user',
				type: 'item',
				icon: 'package-variant-closed',
				url: 'items/list'
			},
			{
				id: 'contacts',
				title: 'Contacts',
				translate: 'CONTACTS',
				type: 'collapse',
				icon: 'book-outline',
				children: [
					{
						id: 'mails',
						title: 'E-mails',
						translate: 'MAILS',
						auth: 'user',
						type: 'item',
						// icon: 'email',
						url: 'mails/list'
					},
					{
						id: 'phones',
						title: 'Phone Numbers',
						translate: 'PHONENUMBERS',
						auth: 'user',
						type: 'item',
						// icon: 'phone',
						url: 'phones/list'
					},
					{
						id: 'socialnetworks',
						title: 'Social Networks',
						translate: 'SOCIALNETWORKS',
						auth: 'user',
						type: 'item',
						// icon: 'web',
						url: 'socialnetworks/list'
					}
				]
			}
		]
	},
	{
		id: 'marketing',
		title: 'Marketing',
		translate: 'MARKETING',
		auth: 'sales',
		type: 'group',
		icon: 'airballoon-outline',
		children: [
			{
				id: 'marketingactions',
				title: 'Marketing Actions',
				translate: 'MARKETINGACTIONS',
				type: 'item',
				icon: 'bullhorn',
				url: 'marketingactions/list'
			},
			{
				id: 'dems',
				title: 'DEMs',
				translate: 'DEMS',
				type: 'item',
				icon: 'email-multiple-outline',
				url: 'dems/list'
			}
		]
	},
	{
		id: 'sales',
		title: 'sales',
		translate: 'SALES',
		type: 'group',
		icon: 'file-document-edit-outline',
		children: [
			{
				id: 'commercialcampaigns',
				title: 'Commercial Campaigns',
				translate: 'COMMERCIALCAMPAIGNS',
				auth: ['sales', 'salesperson'],
				type: 'item',
				icon: 'binoculars',
				url: 'commercialcampaigns/list'
			},
			{
				id: 'opportunities',
				title: 'Opportunities',
				translate: 'OPPORTUNITIES',
				auth: ['sales', 'salesperson'],
				type: 'item',
				icon: 'thought-bubble-outline',
				url: 'opportunities/list'
			},
			{
				id: 'contracts',
				title: 'Contracts',
				translate: 'CONTRACTS',
				type: 'item',
				icon: 'handshake',
				url: 'contracts/list'
			},
			{
				id: 'orders',
				title: 'Orders',
				translate: 'ORDERS',
				auth: ['sales', 'salesperson'],
				type: 'item',
				icon: 'shopping',
				url: 'orders/list'
			},
			{
				id: 'erp-quotations',
				title: 'NAV Quotations',
				translate: 'NAV_QUOTATIONS',
				auth: 'sales',
				type: 'item',
				icon: 'local-offer',
				url: 'erp/quotations/list'
			},
			{
				id: 'erp-orders',
				title: 'NAV Orders',
				translate: 'NAV_ORDERS',
				auth: ['sales', 'salesperson'],
				type: 'item',
				icon: 'basket',
				url: 'erp/orders/list'
			},
			{
				id: 'invoices',
				title: 'Invoices',
				translate: 'INVOICES',
				type: 'item',
				icon: 'invoice-text-outline',
				url: 'invoices/list'
			}
		]
	},
	{
		id: 'management',
		title: 'management',
		translate: 'MANAGEMENT',
		type: 'group',
		icon: 'head-lightbulb-outline',
		children: [
			{
				id: 'projects',
				title: 'Projects',
				translate: 'PROJECTS',
				auth: 'user',
				type: 'item',
				icon: 'clipboard-text-outline',
				url: 'projects/list'
			},
			{
				id: 'activities',
				title: 'Activities',
				translate: 'ACTIVITIES',
				auth: ['user', 'salesperson'],
				type: 'item',
				icon: 'puzzle-outline',
				url: 'activities/list'
			},
			{
				id: 'workreports',
				title: 'Work Reports',
				translate: 'WORKREPORTS',
				auth: 'user',
				type: 'item',
				icon: 'text-box-multiple-outline',
				url: 'workreports/list'
			},
			{
				id: 'chronology',
				title: 'Chronology',
				translate: 'CHRONOLOGY',
				auth: ['user', 'salesperson'],
				type: 'item',
				icon: 'history',
				url: 'chronology/list'
			},
			// {
			// 	id: 'tickets',
			// 	title: 'Tickets',
			// 	translate: 'TICKETS',
			// 	auth: 'user',
			// 	type: 'item',
			// 	icon: 'ticket',
			// 	url: 'tickets/list'
			// },
			{
				id: 'phonecalls',
				title: 'Phone Calls',
				translate: 'PHONECALLS',
				auth: 'user',
				type: 'item',
				icon: 'phone-in-talk',
				url: 'phonecalls/list'
			}
		]
	},
	{
		id: 'system',
		title: 'System',
		translate: 'SYSTEM',
		auth: 'user',
		type: 'group',
		icon: 'cog',
		children: [
			{
				id: 'users',
				title: 'Users',
				translate: 'USERS',
				auth: 'user',
				type: 'item',
				icon: 'account-circle',
				url: 'users/list'
			},
			{
				id: 'groups',
				title: 'Groups',
				translate: 'GROUPS',
				auth: 'user',
				type: 'item',
				icon: 'account-group',
				url: 'groups/list'
			},
			{
				id: 'tags',
				title: 'Tags',
				translate: 'TAGS',
				auth: ['admin', 'sales_admin'],
				type: 'item',
				icon: 'hashtag',
				url: 'tags/list'
			},
			{
				id: 'trash_can',
				title: 'Recycle Bin',
				translate: 'RECYCLE_BIN',
				auth: ['superuser', 'admin'],
				type: 'item',
				icon: 'trash-can-outline',
				url: 'recycle-bin'
			},
			{
				id: 'logs',
				title: 'Logs',
				translate: 'LOGS',
				auth: ['admin', 'sales_admin'],
				type: 'item',
				icon: 'timetable',
				url: 'logs'
			},
			{
				id: 'exchange-mails-logs',
				title: 'Imported Exchange Mails Logs',
				translate: 'EXCHANGE_MAILS_LOGS',
				auth: 'user',
				type: 'item',
				icon: 'mail',
				url: 'exchange/mails/logs'
			},
			{
				id: 'system_tables',
				title: 'System tables',
				translate: 'SYSTEM_TABLES',
				auth: ['admin', 'sales_admin'],
				type: 'item',
				icon: 'remote-desktop',
				url: 'systemtables'
			},
			{
				id: 'permissions_management',
				title: 'Permissions Management',
				translate: 'PERMISSIONS_MANAGEMENT',
				auth: 'dev',
				type: 'item',
				icon: 'shield-lock',
				url: 'permissions-management'
			},
			{
				id: 'settings',
				title: 'Settings',
				translate: 'SETTINGS',
				auth: ['admin', 'sales_admin'],
				type: 'item',
				icon: 'cog',
				url: 'settings'
			}
		]
	}
];

export default navigationConfig;
